const PPQ = 480;
const DEFAULT_VELOCITY = 100;
const DRUM_CHANNEL = 9; // MIDI channel 10 (0-based)
/** @type {Record<number, number>} */
const NOTE_BY_LEVEL = {
    2: 36, // Kick
    1: 38, // Snare
    0: 42, // Hi-hat
};

/** @param {number} n @returns {number[]} */
function u32be(n) {
    return [(n >>> 24) & 0xff, (n >>> 16) & 0xff, (n >>> 8) & 0xff, n & 0xff];
}

/** @param {number} n @returns {number[]} */
function u16be(n) {
    return [(n >>> 8) & 0xff, n & 0xff];
}

/** @param {number} n @returns {number[]} */
function varLen(n) {
    let value = n >>> 0;
    let buffer = value & 0x7f;
    /** @type {number[]} */
    const out = [];
    while ((value >>= 7)) {
        buffer <<= 8;
        buffer |= (value & 0x7f) | 0x80;
    }
    while (true) {
        out.push(buffer & 0xff);
        if (buffer & 0x80) buffer >>= 8;
        else break;
    }
    return out;
}

/** @param {number[]} out @param {number} delta @param {number[]} bytes */
function pushEvent(out, delta, bytes) {
    out.push(...varLen(delta), ...bytes);
}

/**
 * @param {{
 * levels: number[],
 * beatsPerBar: number,
 * subdivision: number,
 * bpm: number,
 * filename?: string
 * }} param0
 */
export function downloadMidiLoop({ levels, beatsPerBar, subdivision, bpm, filename }) {
    const safeSubdivision = Math.max(1, subdivision | 0);
    const safeBpm = Math.max(1, bpm | 0);
    const stepTicks = Math.max(1, Math.floor(PPQ / safeSubdivision));
    const gateTicks = Math.max(1, Math.floor(stepTicks * 0.5));
    const restTicks = stepTicks - gateTicks;

    /** @type {number[]} */
    const track = [];

    const mpqn = Math.round(60_000_000 / safeBpm);
    pushEvent(track, 0, [0xff, 0x51, 0x03, (mpqn >>> 16) & 0xff, (mpqn >>> 8) & 0xff, mpqn & 0xff]);
    pushEvent(track, 0, [0xff, 0x58, 0x04, beatsPerBar & 0xff, 0x02, 24, 8]);

    for (let i = 0; i < levels.length; i++) {
        const level = levels[i] ?? 0;
        const noteMapped = NOTE_BY_LEVEL[level];
        const note = noteMapped === undefined ? 42 : noteMapped;
        pushEvent(track, i === 0 ? 0 : restTicks, [0x90 | DRUM_CHANNEL, note, DEFAULT_VELOCITY]);
        pushEvent(track, gateTicks, [0x80 | DRUM_CHANNEL, note, 0]);
    }

    pushEvent(track, restTicks, [0xff, 0x2f, 0x00]);

    const header = [
        0x4d,
        0x54,
        0x68,
        0x64, // MThd
        ...u32be(6),
        ...u16be(0), // format 0
        ...u16be(1), // one track
        ...u16be(PPQ),
    ];
    const trackChunk = [0x4d, 0x54, 0x72, 0x6b, ...u32be(track.length), ...track]; // MTrk

    const bytes = new Uint8Array([...header, ...trackChunk]);
    const blob = new Blob([bytes], { type: 'audio/midi' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download =
        filename || `metronome-${beatsPerBar}-4-sub${safeSubdivision}-${levels.length}steps.mid`;
    a.click();
    URL.revokeObjectURL(url);
}
